import { Head, Banner, Contact } from "../components/Project";
import { Grid, Space, Table } from "../components/Layout";
import { Title, Texts, Media } from "../components/Object";
import { WorksList, Pagination } from "../components/Post";
import { useParams } from "react-router-dom";
import { useDocumentLoadCompleted } from "../components/Hooks";
import Get, { GetCat } from '../components/Post/Get';
import { Link } from "react-router-dom";

const Works = () => {
  const gridProps = {
    list: {
      gap: ["64px", "24px"],
      layout: ["repeat(3, 1fr)", "100%"],
      size: "100%",
    },
  };

  const isLoaded = useDocumentLoadCompleted();

  const parms = useParams();

  const args = {
    page: parms.id ? parms.id : 1,
    category: parms.category ? parms.category : '',
    type: "works",
    perPage: 6,
  };


  const catArgs = {
    slug: "works-cat",
  };

  const cats = GetCat(catArgs);

  let cateogrys = [];
  let activeCategory;
  let count;
  let activeId;


  if (cats && isLoaded) {

    if (parms.category) {
      activeCategory = cats.find((cat) => cat.id == parms.category);
      activeId = activeCategory.id;
      count = activeCategory.count;
    }

    cateogrys = cats.map((value, key) => {
      let active = activeId == value.id ? 'is-active' : '';
      return (
        <li className={'p-cate__item ' + active} key={key}>
          <Link
            to={`/works/${value.id}`}
          >
            <p className="c-text__min c-text--bold">{value.name}</p>
          </Link>
        </li>
      )
    })
  }

  return (
    <>
      <Head slug="works" type="noimage"></Head>
      <div className="l-row">
        <div className="p-cate__wrap">
          <div className="p-cate__title">
            <p className="c-text__title">カテゴリーで絞り込む</p>
          </div>
          <ul className="p-cate__list">
            <li className={'p-cate__item '}>
              <Link
                to={`/works`}
              >
                <p className="c-text__min c-text--bold">全て</p>
              </Link>
            </li>
            {cateogrys}
          </ul>
        </div>

        <WorksList perPage={args.perPage} category={args.category} page={args.page}></WorksList>

        <Pagination
          category={args.category}
          page={args.page}
          postType={args.type}
          perPage={args.perPage}
          count={count}
        ></Pagination>
      </div>

      <Space size={["200px", "120px"]}></Space>
    </>
  );
};

export default Works;